import React from "react";

import { authRoles } from "app/auth";

const LogNotifyConfig = {
  settings: {
    layout: "admin",
  },
  auth: authRoles.user,
  routes: [
    {
      path: "/log-notify",
      exact: true,
      component: React.lazy(() => import("./log_notify")),
    },
  ],
};

export default LogNotifyConfig;
